import { render, staticRenderFns } from "./AdminGroupsDialog.vue?vue&type=template&id=ec207db0&scoped=true"
import script from "./AdminGroupsDialog.vue?vue&type=script&lang=js"
export * from "./AdminGroupsDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminGroupsDialog.vue?vue&type=style&index=0&id=ec207db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec207db0",
  null
  
)

export default component.exports